export type { AlertDialogOptions } from "./alertDialog.service"

export * as default from "./alertDialog.service"
